<template>
  <v-dialog
    v-model="display"
    persistent
    max-width="600px"
    scrollable
    v-if="display"
  >
    <v-form ref="avisCropForm">
      <v-card min-height="200px">
        <v-card-title>
          <v-row>
            <v-col class="headline">Gestion de la demande</v-col>
          </v-row>
        </v-card-title>
        <v-card-text class="text--primary">
          <v-row><v-col>Cette demande d'agrément concerne:</v-col></v-row>
          <v-container>
            <v-row>
              <v-col>établissement: {{ dossier.officine.denomination }}</v-col>
              <v-col
                >date de la demande: {{ getDate(dossier.dateDepot) }}</v-col
              >
            </v-row>
            <v-row>
              <v-col>demandeur: {{ dossier.demandeur }}</v-col>
              <v-col
                >type de la demande:
                {{
                  dossier.premiereDemande
                    ? "Première demande"
                    : "Renouvellement"
                }}</v-col
              >
            </v-row>
            <v-row>
              <v-col><v-divider></v-divider></v-col>
            </v-row>
            <v-row>
              <v-col><u>Saisie de l'avis :</u></v-col>
            </v-row>
            <v-container>
              <v-row class="mt-0">
                <v-col class="pt-0">
                  <b>critère de moralité :</b>
                  <v-radio-group
                    ref="formCritereMoralite"
                    v-model="avis.critereMoralite"
                  >
                    <v-radio :value="true" label="favorable"></v-radio>
                    <v-radio :value="false" label="défavorable"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <b>DPC validée :</b>
                  <v-radio-group ref="formDPCValide" v-model="avis.dpcValidee">
                    <v-radio :value="true" label="favorable"></v-radio>
                    <v-radio :value="false" label="défavorable"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>

              <v-row>
                <v-col class="pt-0">
                  <v-textarea
                    v-model="avis.commentaire"
                    label="commentaire :"
                    class="pa-1 mt-0"
                    hide-details
                    counter
                    :rules="commentaireRules"
                  >
                  </v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-radio-group v-model="avis.avis" :rules="avisRules">
                    <v-radio :value="true" label="avis favorable"></v-radio>
                    <v-radio :value="false" label="avis défavorable"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-container>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <p v-if="!formValid" class="text-caption red--text">
            Un ou plusieurs champs sont mal renseignés
          </p>
          <v-spacer></v-spacer>
          <v-btn small class="white--text" @click="sendAction" color="primary">
            Enregistrer
          </v-btn>
          <v-btn
            small
            class="white--text"
            @click="displayed = false"
            color="primary"
          >
            Annuler
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import common from "@/common";

export default {
  name: "ModalEditAvisCROP",
  props: ["avis", "dossier", "display"],
  data() {
    return {
      formValid: true,
      avisRules: [v => v !== null || "Vous devez donner un avis."],
      commentaireRules: [v => v.length <= 2000 || "2000 caractères maximum"]
    };
  },
  mounted() {
    if (this.avis.id == undefined) {
      this.$refs.formCritereMoralite.reset();
      this.$refs.formDPCValide.reset();
    }
  },
  computed: {
    displayed: {
      get() {
        return this.display;
      },
      set(value) {
        this.$emit("update:display", value);
      }
    }
  },
  methods: {
    sendAction() {
      if (this.$refs.avisCropForm.validate()) {
        this.formValid = true;
        this.$emit("ModalAvisCROPAction", this.avis);
        this.displayed = false;
        this.$toast.success("L'avis a été enregistré");
      } else {
        this.formValid = false;
      }
    },
    getDate(timestamp) {
      return common.formatDate(timestamp);
    }
  }
};
</script>
